/**
 * useAdminAccess
 *
 * Composable для проверки доступа к админ-панели.
 * Доступ имеет только системный администратор (antalsin@yandex.ru).
 *
 * В режиме DEV (Vite dev server) можно обойти проверку авторизации,
 * добавив ?devAdmin=true в URL.
 */

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

/** Email системного администратора */
export const SYSTEM_ADMIN_EMAIL = 'antalsin@yandex.ru'

/**
 * Composable для проверки доступа к админ-панели
 */
export function useAdminAccess() {
  const authStore = useAuthStore()
  const route = useRoute()

  /** Активен ли DEV_MODE с обходом авторизации */
  const isDevMode = computed(() => {
    if (!import.meta.env.DEV) return false
    return route.query.devAdmin === 'true'
  })

  /** Является ли текущий пользователь системным администратором */
  const isSystemAdmin = computed(() => {
    // DEV_MODE: разрешить доступ с ?devAdmin=true
    if (isDevMode.value) return true
    return authStore.user?.email === SYSTEM_ADMIN_EMAIL
  })

  /** Авторизован ли пользователь */
  const isAuthenticated = computed(() => {
    if (isDevMode.value) return true
    return authStore.isAuthenticated
  })

  /** Email текущего пользователя */
  const userEmail = computed(() => {
    if (isDevMode.value) return 'dev@localhost'
    return authStore.user?.email
  })

  return {
    isSystemAdmin,
    isAuthenticated,
    isDevMode,
    userEmail,
    SYSTEM_ADMIN_EMAIL,
  }
}
